import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { ProviderModel } from "../models/ProviderModels/ProviderModel";
import { DefaultProviderModel } from '../models/ProviderModels/DefaultProviderModel';
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  ApiUrl = "/api/admin/Provider/"

  constructor(private http: RequestHandlerService) { }

  AddProvider( AddModel: ProviderModel) {
   
    return this.http.post( this.ApiUrl + 'AddProvider', AddModel);
  }
  
  GetEditProviderData(id:string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get( this.ApiUrl + 'EditProvider',  params );

  }

  EditProvider( EditModel: ProviderModel) {
   
    return this.http.post( this.ApiUrl + 'EditProvider', EditModel);
  }

  DeleteProvider( id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.post( this.ApiUrl + 'DeleteProvider', null,  params);
  }
  Loaddropdowns() {
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  LoaddropdownsForAdd() {   
    return this.http.get(this.ApiUrl + 'LoaddropdownsForAdd');
  }
GetProviderAttributes(typeFullName:string){
  
   let params = new HttpParams();
    params = params.append("typeFullName", typeFullName);
    return this.http.post( this.ApiUrl + 'GetProviderAttributes', null , params);

}
  GenerateProviderJson() {
    let options:RequestOptionsModel=new RequestOptionsModel()
    options.responseType= "arraybuffer" 
    return this.http.post( this.ApiUrl + 'GenerateProviderJson', null, null, options);
  }

  GetDefaultProviders() {
    return this.http.get( this.ApiUrl + 'SelectDefaultProvider');

  }
  SubmitDefaultProviders(DefaulrProvidersModel: DefaultProviderModel[]) {
  
    return this.http.post( this.ApiUrl + 'SubmitDefaultProvider', DefaulrProvidersModel);
  }
}
